import React from 'react';
import ReactDOM from 'react-dom';

import {provider} from './startup/provider.js';

ReactDOM.render(
	<div>
		{provider}
 	</div>,
 	document.getElementById('app')
);





// WEBPACK FOOTER //
// ./src/index.js